module.exports = __webpack_public_path__ + "static/media/Wind.8c702e2a.webp";